import { render } from "./InlinePreloader.vue?vue&type=template&id=726bd7e1"
import script from "./InlinePreloader.vue?vue&type=script&lang=js"
export * from "./InlinePreloader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Note\\WEB DESIGN\\NEED FILE\\PRACTICE\\VUE PROJECTS\\royal-shop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__